const THREE = require('three') 
import { DEG_TO_RAD, clamp  } from '@/helpers/MathUtils'
import DoorIrisFbo from '@/components/Stage/intro/doors-iris-fbo'
import frag from '@/shaders/iris.frag'
import vert from '@/shaders/bg/sky.vert'
 
class DoorIris extends THREE.Group {

  constructor(config) {

    super(); 

    this.renderer = config.renderer; 
    this.position.z = -10;  
    this.setup();
    this.resize()
  } 

  setup() {

    this.doorIrisFbo = new DoorIrisFbo({
      renderer : this.renderer, 
      container: this
    });


    if(this.doorIrisFbo.USE_FBO){
      var texture = this.doorIrisFbo.getTexture(); 
      var geometry = new THREE.PlaneBufferGeometry( 1024 * 0.12, 1024 * 0.12 , 1);
     
      var material = new THREE.ShaderMaterial({ 
        vertexShader : vert,
        fragmentShader : frag,
        uniforms : {
          tIrisFbo: texture
        }, 
        transparent: true 
      });  
      material.needsUpdate = true;
      this.plane = new THREE.Mesh(geometry, material);
      // this.plane.scale.x = this.plane.scale.y = this.plane.scale.z = 0.5;
      this.add(this.plane);
    } 
  }

  updateRoute(val) { 
    this.doorIrisFbo.updateRoute(val) 
  }

  tick(){  
    this.doorIrisFbo.tick();
 
    let texture = this.doorIrisFbo.getTexture(); 
      this.plane.material.uniforms.tIrisFbo.value = texture  
  }

  resize() { 
    this.doorIrisFbo.resize();
  }

}

export default DoorIris